"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparatorDateInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Popover = __importStar(require("@radix-ui/react-popover"));
const react_1 = require("react");
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const ComparatorTrigger_1 = require("./ComparatorTrigger");
const date_1 = require("../../constants/date");
const translate_1 = require("../../translate");
const Paper_1 = require("../Paper");
const ComparatorDateInput = ({ children, value, onSelect, }) => {
    const t = (0, translate_1.useTranslations)();
    const locale = (0, translate_1.useLocale)();
    const localeOptions = date_1.DATE_FNS_LOCALE_OPTIONS[locale];
    const [isOpen, setIsOpen] = (0, react_1.useState)(true);
    const handleSelect = (selectedValue) => {
        setIsOpen(false);
        onSelect(selectedValue ? Math.floor(selectedValue.getTime() / 1000) : null);
    };
    const label = value
        ? t.$date.unix(value).format('ll')
        : t.form.select_a_date();
    return ((0, jsx_runtime_1.jsxs)(Popover.Root, { open: isOpen, onOpenChange: (open) => setIsOpen(open), children: [(0, jsx_runtime_1.jsx)(Popover.Trigger, { asChild: true, children: (0, jsx_runtime_1.jsx)(ComparatorTrigger_1.ComparatorTrigger, { design: "bold", children: children ?? label }) }), (0, jsx_runtime_1.jsx)(Popover.Content, { sideOffset: 4, align: "center", style: {
                    /*
                      Z index was added since the popover was otherwise rendered under other elements like
                      the table in the vacancies list where it was used. Note that the table didn't have any
                      z-index set.
                    */
                    zIndex: 1,
                }, children: (0, jsx_runtime_1.jsx)(react_datepicker_1.default, { calendarContainer: ({ className, children }) => ((0, jsx_runtime_1.jsx)(Paper_1.Paper, { className: className, children: children })), dateFormat: localeOptions.dateFormat.short, inline: true, locale: localeOptions.locale, onChange: handleSelect, selected: value ? new Date(value * 1000) : null, showWeekNumbers: true }) })] }));
};
exports.ComparatorDateInput = ComparatorDateInput;
